import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

const { NAME, NAME_BN, ADDRESS, ADDRESS_BN, TYPE, DIVISION, DISTRICT } =
  FORM_FIELDS.HRM_SETTINGS.CREATE_OFFICE;

export const banglaTextFormat =
  /^[\u0980-\u09FF\u09E6-\u09EF\s!@#\$%\^&\*\(\)\-_=+\[\]{};:'",<>\.\?\/\\|`~]+$/;
export const englishTextFormate =
  /^[a-zA-Z0-9\s!@#\$%\^&\*\(\)\-_=+\[\]{};:'",<>\.\?\/\\|`~]+$/;

export const HRMSettingsOfficeValidation = yup.object().shape({
  [NAME]: yup
    .string()
    .required("Name (English) is required")
    .matches(englishTextFormate, "Please provide office name (In English)"),
  [NAME_BN]: yup
    .string()
    .required("Name (Bangla) is required")
    .matches(banglaTextFormat, "Please provide office name(In Bangla)"),
  [ADDRESS]: yup
    .string()
    .required("Address (English) is required")
    .matches(englishTextFormate, "Please provide office address(In English)"),
  [ADDRESS_BN]: yup
    .string()
    .required("Address (Bangla) is required")
    .matches(banglaTextFormat, "Please provide office address(In Bangla)"),
  [TYPE]: yup
    .number()
    .required("Type is required")
    .typeError("Type is required"),
  [DIVISION]: yup
    .number()
    .required("Type is required")
    .typeError("Type is required"),
  [DISTRICT]: yup
    .number()
    .required("Type is required")
    .typeError("Type is required"),
});

export type HRMSettingsOfficeFormDataType = yup.InferType<
  typeof HRMSettingsOfficeValidation
>;
